import React, {Component} from 'react';
import {Button, Form, Grid, Header, Icon, Modal, Message,Segment} from "semantic-ui-react";
import InspectionContainer from "../../containers/inspection_container";
import {getAgentsOfCompany} from "../../data/user_api";
import {COMPANY_API_URL, INSPECTION_API_URL} from '../../constants/api_routes';
import {createInspection} from "../../data/inspection_api";
import moment from 'moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import CreateAgentUser from "../user/agent/create_user";
import Loader from "../universal/loader";
import AssignClerk from "./assign_clerk";
import { getPropertyDetails } from "../../data/user_api";
import ViewPropertyDetails from "../properties/view_property_details"

class InspectionGeneralDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            agentListOptions: [],
            assignedAgent: undefined,
            jobType: undefined,
            invoiceIsDefault: true,
            displayAdditionalInvoiceOption: false,
            reportType: undefined,
            inspectionDate: undefined,
            inspectionTime: moment(),
            inspectionStartTime: moment().hour(8).minute(0).format("YYYY-MM-DD HH:mm"),
            inspectionEndTime: moment().hour(17).minute(0).format("YYYY-MM-DD HH:mm"),
            RequestedTime: undefined,
            showCustomTimeSelect: 'none',
            agentValid: true,
            jobTypeValid: true,
            reportTypeValid: true,
            dateValid: true,
            timeValid:false,
            showErrorInfo: false,
            showAddAgentWindow: false,
            defaultEndTime:moment().hour(17).minute(0),
            showClerkAvailability:false,
            numberOfBedroom:undefined,
            furnishingType:'unfurnished',
            original_report_from_another_company: undefined,
            getKeysFrom:undefined,
            returnKeysTo:undefined

        };
    }

    componentWillMount() {
        const user = JSON.parse(localStorage.getItem('user'));
        this.setState({currentUser:user});
        if (this.props.companyId) {
            this.getAgentList(this.props.companyId).then(() => {
            });
        }
        const furnishing = ["furnished","unfurnished","semifurnished"];
        this.setState({numberOfBedroom:(this.props.propertyDetails['no_of_bedrooms'] === "studio" ? "0" : this.props.propertyDetails['no_of_bedrooms']) ,furnishingType:furnishing.indexOf(this.props.propertyDetails['furnishing_type']).toString()})
    }

    getPropertyDetails = async () => {
        let propertyDetails = await getPropertyDetails(this.props.propertyDetails["id"])
        this.setState({propertyDetails: propertyDetails,fetchingPropertyDetails:false})
    }
    getAgentList = async (companyId) => {
        const agentList = await getAgentsOfCompany(COMPANY_API_URL, companyId);
        let agentOptions = [];
        for (let i = 0; i < agentList.length; i++) {
            let obj = {
                key: agentList[i].id,
                text: agentList[i].name,
                value: agentList[i].id
            };
            agentOptions.push(obj);
        }
        this.setState({agentListOptions: agentOptions});
    };

    handleSubmit = (e) => {
        e.preventDefault();

        if (this.state.assignedAgent === undefined) {
            this.setState({agentValid: false, showErrorInfo: true});
            return null;
        }
        if (this.state.jobType === undefined) {
            this.setState({jobTypeValid: false, showErrorInfo: true});
            return null;
        }
        if (this.state.currentUser.role !== 'agent' && this.state.reportType === undefined) {
            this.setState({reportTypeValid: false, showErrorInfo: true});
            return null;
        }
        if (this.state.inspectionDate=== undefined) {
            this.setState({dateValid: false, showErrorInfo: true});
            return null;
        }

        if (this.state.timeValid === false ) {
            this.setState({showErrorInfo: true});
            return null;
        }
        if (this.state.inspectionStartTime === undefined || this.state.inspectionEndTime === undefined ) {
            this.setState({timeValid: false, showErrorInfo: true});
            return null;
        }
        if (this.state.numberOfBedroom === undefined) {
            this.setState({invalidRoomCount: true});
            return null;
        }

        if (this.state.furnishingType === undefined) {
            this.setState({furnishInvalid: true});
            return null;
        }

        this.setState({isCreating:true});
        const formData = new FormData(e.target);
        formData.append("property_id", this.props.propertyId);
        formData.append("report_type",(this.state.currentUser.role === 'agent' && this.state.reportType === undefined) ? (this.state.original_report_from_another_company == true && this.state.jobType == "co") ? "other" :"standard" : this.state.reportType);
        formData.append("get_keys_from", this.state.getKeysFrom||"");
        formData.append("return_keys_to", this.state.returnKeysTo || "");
        formData.append("agent_profile_id", this.state.assignedAgent);
        formData.append("inspection_type", this.state.jobType);
        formData.append("inspection_start_time", moment(this.state.inspectionStartTime).format("YYYY-MM-DD HH:mm"));
        formData.append("inspection_end_time", moment(this.state.inspectionEndTime).format("YYYY-MM-DD HH:mm"));
        formData.append("default_invoice", this.state.invoiceIsDefault ? "true" : "false");
        formData.append("property_size", this.state.numberOfBedroom);
        formData.append("furnishing_type", this.state.furnishingType);

        this.createInspection(formData).then((response) => {
            if (response.success) {
                if(this.state.reportType == "other") {
                    this.props.setOtherReport()
                }
                this.props.setNewInspectionIdCreated(response['inspection_id']);
                this.prepareDataForAssignClerk().then(() => {
                })
            }
            else {
                this.setState({showErrorInfo: true, errorMessage: response.error});
            }
            this.setState({isCreating:false});
        })
    };

    onStartChange = (value) => {
        if(!this.state.inspectionDate){
            this.setState({dateValid:false});
            return;
        }
        if(value) {
            this.setState({inspectionStartTime: moment(this.state.inspectionDate, "DD-MM-YYYY").hour(value.get('hour')).minute(value.get('minute')).format("YYYY-MM-DD HH:mm"),inspectionEndTime: moment(this.state.inspectionDate, "DD-MM-YYYY").hour(value.get('hour')).minute(value.get('minute')).add(0.5,"hour").format("YYYY-MM-DD HH:mm"),defaultEndTime:moment(this.state.inspectionDate, "YYYY-MM-DD").hour(value.get('hour')).minute(value.get('minute')).add(0.5,"hour")});
        }
        else {
            this.setState({inspectionStartTime: moment(this.state.inspectionDate, "DD-MM-YYYY").hour(8).minute(0).format("YYYY-MM-DD HH:mm"),inspectionEndTime: moment(this.state.inspectionDate, "DD-MM-YYYY").hour(17).minute(0).format("YYYY-MM-DD HH:mm"),defaultEndTime:moment(this.state.inspectionDate, "YYYY-MM-DD").hour(17).minute(0)});
        }
    };

    onEndChange = (value) => {
        if(value) {
            this.setState({inspectionEndTime: moment(this.state.inspectionDate, "DD-MM-YYYY").hour(value.get('hour')).minute(value.get('minute')).format("YYYY-MM-DD HH:mm"),defaultEndTime:value});
        }
        else {
            this.setState({inspectionEndTime: moment(this.state.inspectionDate, "DD-MM-YYYY").hour(17).minute(0).format("YYYY-MM-DD HH:mm"),defaultEndTime:moment(this.state.inspectionDate, "DD-MM-YYYY").hour(17).minute(0)});
        }
    };

    createInspection = async (formData) => {
        return await createInspection(INSPECTION_API_URL, formData);
    };

    prepareDataForAssignClerk = async () => {
        this.props.onComplete(moment(this.state.inspectionDate).format("YYYY-MM-DD"),this.state.inspectionStartTime,this.state.inspectionEndTime);
    };

    onNewAgentAdded = () => {
        if (this.props.companyId) {
            this.getAgentList(this.props.companyId).then(() => { this.setState({showAddAgentWindow:false})
            });
        }
    };

    disabledHours = () => {
        return [0,1,2,3,4,5,6];
    };

    render() {
        const furnishing = ["furnished","unfurnished","semifurnished"];

        const user = this.state.currentUser;
        const furnishOptions = [
            {key: '1', text: 'Furnished', value: '0'},
            {key: '2', text: 'Part-Furnished', value: '2'},
            {key: '3', text: 'Un-Furnished', value: '1'},
        ];

        const bedRoomOptions = [
            {key: '1', text: 'Studio', value: '0'},
            {key: '2', text: '1 Bedroom', value: '1'},
            {key: '3', text: '2 Bedroom', value: '2'},
            {key: '4', text: '3 Bedroom', value: '3'},
            {key: '5', text: '4 Bedroom', value: '4'},
            {key: '6', text: '5 Bedroom', value: '5'},
            {key: '7', text: '6 Bedroom', value: '6'},
            {key: '8', text: '7 Bedroom', value: '7'},
            {key: '9', text: '8 or Above Bedroom', value: '8'},
        ];

        let jobTypeOptions = [
            {key: 1, text: 'CI', value: 'ci'},
            {key: 2, text: 'CO', value: 'co'},
            {key: 3, text: 'INV/CI', value: 'inv/ci'},
            {key: 4, text: 'INV', value: 'inv'},
 
        ];

        if (this.state.currentUser.role !== 'agent') {
            jobTypeOptions.push( 
            {key: 8, text: 'PV', value: 'pv'},
            {key: 5, text: 'REV', value: 'rev'},
            {key: 6, text: 'CLN', value: 'cln'},
            {key: 7, text: 'SNG', value: 'sng'}
        )}

        const reportTypeOptionsCI = [
            {key: 1, text: 'Hinch Standard', value: 'standard'},
            {key: 2, text: 'Custom - Upload File', value: 'custom'},
            {key: 3, text: 'New', value: 'new'}
        ];

        const reportTypeOptionsCO = [
            {key: 1, text: 'Hinch Standard', value: 'standard'},
            { key: 2, text: 'Custom - Upload File', value: 'custom' },
            { key: 3, text: 'New - Other Template', value: 'other' },

        ];
        const reportTypeOptionsPV = [
            {key: 1, text: 'Custom - Upload File', value: 'custom'}
        ];

        const timeOptions = [
            {key: 0, text: 'Anytime', value: '0'},
            {key: 1, text: 'Anytime AM', value: '1'},
            {key: 2, text: 'Anytime PM', value: '2'},
            {key: 3, text: 'Custom Time', value: '3'}
        ];

        const handleDateRangeSelection = (e, option) => {
            switch (option.value) {
                case '0':
                    setDateTimes(option.value, 8, 18);
                    break;
                case '1':
                    setDateTimes(option.value, 8, 12);
                    break;
                case '2':
                    setDateTimes(option.value, 12, 18);
                    break;
                default:
                    setDateTimes(option.value, 8, 18);
            }

        };

        const setDateTimes = (requestedSlot, startTime, endTime) => {
            this.setState({
                RequestedTime: requestedSlot,
                timeValid:true,
                inspectionStartTime: moment(this.state.inspectionDate).hour(startTime).minute(0).format("YYYY-MM-DD HH:mm"),
                inspectionEndTime: moment(this.state.inspectionDate).hour(endTime).minute(0).format("YYYY-MM-DD HH:mm")
            });
        };

        const timeFormat = 'HH:mm';

        return (
            <Form onSubmit={this.handleSubmit} type="multipart/formdata" style={{width: '80%', margin: 'auto'}}>
                <Button onClick={(e)=>{e.preventDefault(); console.log("ALL PROPS", this.props);
console.log("setOtherReport", this.props.setOtherReport);
console.log("typeof", typeof this.props.setOtherReport);}}>LOG</Button>
                <Header content="General Details " size='large' textAlign='center'/>
                {this.props.booking_requirements && this.props.userRole == "admin" && <Message
                    header='Client Requirements'
                    content={this.props.booking_requirements.split("\n").map((value, index) => {return (<React.Fragment key={index}>{value}<br /></React.Fragment>);})}></Message>}
                    {this.props.agent_booking_requirements && <Message
                    header='Agent Booking Guidance'
                    content={this.props.agent_booking_requirements.split("\n").map((value, index) => {return (<React.Fragment key={index}>{value}<br /></React.Fragment>);})}></Message>}
                {this.state.isCreating && <Loader/>}
                <Grid columns={2} stackable>
                    <Grid.Column>
                        <div>
                            <div className="pull-left" style={{width:'85%'}}>
                                <Form.Dropdown
                                    label='Agent Name'
                                    required
                                    search
                                    noResultsMessage="Agent not found"
                                    error={!this.state.agentValid}
                                    selection
                                    wrapSelection={false}
                                    selectOnBlur={false}
                                    options={this.state.agentListOptions}
                                    placeholder='Agent Name'
                                    onFocus={()=>this.setState({agentValid:true})}
                                    onChange={(e, option) => {
                                        this.setState({assignedAgent: option.value})
                                    }}
                                />
                            </div>
                            <div style={{marginTop:'7%',paddingBottom:'6%'}} className="pad-left pull-left icon-button" onClick={()=>{this.setState({showAddAgentWindow:true})}}>
                                 <Icon name='user plus' size="large" />
                            </div>
                        </div>
                        <Form.Input label='Agent Reference ID' placeholder='AX67492GT'
                                    name="reference_id"/>
                        <Form.Dropdown
                            label='Job Type'
                            required
                            selection
                            error={!this.state.jobTypeValid}
                            wrapSelection={false}
                            selectOnBlur={false}
                            options={jobTypeOptions}
                            placeholder='CI'
                            onFocus={()=>this.setState({jobTypeValid:true})}
                            onChange={(e, option) => {
                                this.setState({jobType: option.value})
                                if(option.value === "co" && this.state.reportType ==="new" || this.state.reportType ==="other" && option.value !== "co"  )  {this.setState({reportType:undefined})}
                                if((option.value === "pv" || option.value === "rev"|| option.value === "cln")  && this.state.reportType !=="custom" ) {this.setState({reportType:undefined})}
                            }}
                        />
                        {user && user.role !== "agent" && <Form.Group widths={2}>
                            <Form.Input placeholder='Clerk Pay/Extra Charge' label = "Clerk Pay/Extra Charge"
                                        name="clerk_charge" />
                            <Form.Input placeholder='Invoice Price/Extra Charge' label = "Invoice Price/Extra Charge"
                                        name="invoice_charge"/>
                        </Form.Group>}
                        {user && user.role !== 'agent' && <Form.Dropdown
                            label='Report Type'
                            required
                            selection
                            selectOnBlur={false}
                            error={!this.state.reportTypeValid}
                            wrapSelection={false}
                            options={this.state.jobType === 'co'?reportTypeOptionsCO:(this.state.jobType ==="pv" ||this.state.jobType ==="rev" ||this.state.jobType ==="cln") ? reportTypeOptionsPV:reportTypeOptionsCI}
                            placeholder='New'
                            upward
                            onFocus={()=>this.setState({reportTypeValid:true})}
                            onChange={(e, option) => {
                                this.setState({reportType: option.value})
                            }}
                        />}

                         {user && user.role == 'agent' && this.state.jobType == "co" && <Form.Field>
                         <label>Original Report is from another company?</label> <Button onClick={(e)=>{e.preventDefault();this.setState({original_report_from_another_company:true})}}positive={this.state.original_report_from_another_company == true}>Yes</Button><Button onClick={(e)=>{e.preventDefault();this.setState({original_report_from_another_company:false})}} positive={this.state.original_report_from_another_company == false}>No</Button>  </Form.Field>
                        }
                    </Grid.Column>
                    <Grid.Column>
                        <Form.Field><label>Get Keys From</label>
                    {user && user.role != "agent" || (user && user.role == "agent" && this.state.getKeysFrom) ? <Form.Input value={this.state.getKeysFrom} onChange={(e)=>{this.setState({getKeysFrom:e.target.value})}} icon='key' iconPosition='left' placeholder='Keys from'
                                    name="get_keys_from"/> : <Button.Group vertical compact>
                                        <Button content="Agent Office" onClick={()=>this.setState({getKeysFrom:"Agent Office"})}></Button>
                                        <Button content="Meet Tenant (confirmed by Agent)" onClick={()=>this.setState({getKeysFrom:"Meet Tenant"})}></Button>
                                        <Button content="Meet Tenant (Hinch to contact)" onClick={()=>this.setState({getKeysFrom:"Meet Tenant ? (Hinch to contact)"})}></Button>
                                        <Button content="Other (Free Type)" onClick={()=>this.setState({getKeysFrom:" "})}></Button>
                                        </Button.Group> }</Form.Field>
                      <Form.Field><label>Return Keys To</label>
                    {user && user.role != "agent" || (user && user.role == "agent" && this.state.returnKeysTo) ? <Form.Input value={this.state.returnKeysTo} onChange={(e)=>{this.setState({returnKeysTo:e.target.value})}} icon='key' iconPosition='left' placeholder='Keys from'
                                    name="return_keys_to"/> : <Button.Group vertical compact>
                                        <Button content="Agent Office" onClick={()=>this.setState({returnKeysTo:"Agent Office"})}></Button>
                                        <Button content="Meet Tenant (confirmed by Agent)" onClick={()=>this.setState({returnKeysTo:"Meet Tenant"})}></Button>
                                        <Button content="Meet Tenant (Hinch to contact)" onClick={()=>this.setState({returnKeysTo:"Meet Tenant ? (Hinch to contact)"})}></Button>
                                        <Button content="Other (Free Type)" onClick={()=>this.setState({returnKeysTo:" "})}></Button>
                                        </Button.Group> }</Form.Field>
                        <Form.Group widths={2}>
                        <Form.Dropdown
                            label="No. of Bedrooms"
                            required
                            selection
                            error={this.state.invalidRoomCount}
                            wrapSelection={false}
                            options={bedRoomOptions}
                            placeholder='No. of bedrooms'
                            selectOnBlur={false}
                            defaultValue={this.props.propertyDetails['no_of_bedrooms'] === "studio" ? "0" : this.props.propertyDetails['no_of_bedrooms']  }
                            onFocus={()=>this.setState({invalidRoomCount:false})}
                            onChange={(e, option) => {
                                this.setState({numberOfBedroom: option.value})
                            }}
                        />
                        <Form.Dropdown
                            label="Furnishing Type"
                            required
                            selection
                            error={this.state.furnishInvalid}
                            wrapSelection={false}
                            selectOnBlur={false}
                            options={furnishOptions}
                            defaultValue={furnishing.indexOf(this.props.propertyDetails['furnishing_type']).toString()}
                            placeholder='Furnishing Type'
                            onFocus= {()=>this.setState({furnishInvalid:false})}
                            onChange={(e, option) => {
                                this.setState({furnishingType: option.value})
                            }}
                        />
                        </Form.Group>
                        <div className='fields'>
                        <div className='ui field fourteen wide'>
                            <span className='required field'><label><b>Date: </b></label></span><span className={this.state.dateValid?'field':'field ui error'}><DayPickerInput
                            placeholder="DD-MM-YYYY"
                            dayPickerProps={{
                                todayButton: 'Today',
                                firstDayOfWeek : 1,
                            }}
                            format="DD-MM-YYYY"
                            formatDate={formatDate}
                            parseDate={parseDate}
                            value={this.state.inspectionDate}
                            onDayChange={day => {if(day) { this.setState({
                                inspectionDate: day,
                                dateValid:true,
                                inspectionStartTime:moment(day).hour(parseInt(moment(this.state.inspectionStartTime).format("HH"))).minute(parseInt(moment(this.state.inspectionStartTime).format("mm"))).format("YYYY-MM-DD HH:mm"),
                                inspectionEndTime:moment(day).hour(parseInt(moment(this.state.inspectionEndTime).format("HH"))).minute(parseInt(moment(this.state.inspectionEndTime).format("mm"))).format("YYYY-MM-DD HH:mm"),
                            })}
                            else {
                                this.setState({dateValid:false,inspectionDate:undefined});
                            }
                            }}/></span>
                        </div>
                            {user && user.role === 'admin' && this.state.inspectionDate && <div className=" two wide field icon-button" style={{marginTop:'7%',paddingBottom:'6%'}}>
                                <Icon name="calendar" size="large" onClick={()=>{this.setState({showClerkAvailability:true})}} />
                            </div>}
                        </div>
                        <Form.Dropdown
                            label='Time Of Inspection'
                            required
                            selection
                            disabled={!this.state.inspectionDate}
                            error={!this.state.timeValid}
                            wrapSelection={false}
                            options={timeOptions}
                            placeholder='Select Time'
                            selectOnBlur={false}
                            onChange={handleDateRangeSelection}
                        />
                        {this.state.RequestedTime === '3' && <div>
                            <Form.Group inline>
                                <TimePicker
                                    showSecond={false}
                                    placeholder='08:00'
                                    defaultValue={moment().hour(8).minute(0)}
                                    className="time-width"
                                    onChange={this.onStartChange}
                                    format={timeFormat}
                                    minuteStep={15}
                                    disabledHours={this.disabledHours}
                                    hideDisabledOptions={true}
                                    inputReadOnly
                                /><span>--</span>
                                <TimePicker
                                    showSecond={false}
                                    value={this.state.defaultEndTime}
                                    defaultValue={moment().hour(17).minute(0)}
                                    placeholder='17:00'
                                    className="time-width"
                                    onChange={this.onEndChange}
                                    format={timeFormat}
                                    minuteStep={15}
                                    disabledHours={this.disabledHours}
                                    hideDisabledOptions={true}
                                    inputReadOnly
                                />
                            </Form.Group>
                        </div>}
                        <Form.Input label='Tenant Name' icon='user' iconPosition='left' placeholder='Tenant Name'
                                    name="tenant_name"/>
                        <Form.Input label='Tenant Contact' icon='tty' iconPosition='left'
                                    placeholder='Tenant Contact eg.44533421/abc@abc.co'
                                    type='text' name="tenant_contact"/>
                    </Grid.Column>
                    <div className="submit-buttons">
                        <Button type='submit' primary fluid disabled={this.state.isCreating}>Create Inspection</Button>
                    </div>
                </Grid>
                <Segment textAlign="center">  
                    {!this.state.showPropertyDetails ? <Button onClick={() => { this.setState({ showPropertyDetails: true }); this.getPropertyDetails() }}> Show Property Details</Button> : this.state.fetchingPropertyDetails ? <Button loading > Loading </Button> : <ViewPropertyDetails userRole={this.props.userRole} disableMerge={true} selectedObject={[this.props.propertyDetails]}/>}</Segment>
                <div style={{minHeight:'50px'}}></div>
                <Modal size="large" open={this.state.showAddAgentWindow || this.state.showClerkAvailability} onClose={(e) => {
                    this.setState({showAddAgentWindow: false,showClerkAvailability:false})
                }}>
                    <Modal.Content>
                        <div style={{position:'absolute',right:'10px'}}>
                            <Button basic icon negative onClick={(e) => {
                                this.setState({showAddAgentWindow: false,showClerkAvailability:false})
                            }}><Icon name="close"/></Button>
                        </div>
                        <Modal.Description>
                            {this.state.showClerkAvailability ? <div style={{minHeight:'500px'}}><AssignClerk date={this.state.inspectionDate} viewOnly={true} /></div> :
                         <CreateAgentUser onSuccess={this.onNewAgentAdded} companyId={this.props.companyId}/>}
                        </Modal.Description>
                    </Modal.Content>
                </Modal>
            </Form>);
    }
}

export default InspectionContainer(InspectionGeneralDetails);


// WEBPACK FOOTER //
// ./src/views/inspection/general_details.js